<!--候补设置-->
<template>
    <el-drawer
        title="候补设置"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <div v-if="itemData">
                <el-card header="参考信息" class="card1 MT20">
					<div class="item">
					    <label class="color-info">票品名称：</label><b>{{itemData.ticketName}}</b>
					</div>
					<div class="item">
					    <label class="color-info">票品库存：</label>
						<b>
							总共：<span class="color-danger">{{itemData.totalNum}}</span> 
							已销售：<span class="color-danger">{{itemData.sellNum + itemData.successCount}}</span>
							待支付：<span class="color-danger">{{itemData.occupyNum}}</span>
							剩余可售：<span class="color-danger">{{itemData.leftNum}}</span>
							候补库存：<span class="color-danger">{{itemData.altLeftNum}}</span>
							候补中：<span class="color-danger">{{itemData.amidCount}}</span>
							缺票：<span class="color-danger">{{itemData.lackTicketsNum}}人</span>
						</b>
					</div>
					<div class="item">
					    <label class="color-info">销售时间：</label><b class="color-blue">{{itemData.startTime}} 至 {{itemData.endTime}}</b>
					</div>
					<div class="item" v-if="itemTime">
					    <label class="color-info">演出开演时间：</label><b class="color-blue">{{itemTime}}</b>
					</div>
					<div class="item">
					    <label class="color-info">账号限购：</label><b>{{itemData.accountLimitNum == 0 ? '不限购' : itemData.accountLimitNum}}</b>
					</div>
					<div class="item">
					    <label class="color-info">强制售罄：</label><b class="color-danger">{{itemData.isSoldOut == 1 ? '是' : '否'}}</b>
					</div>
                </el-card>
			</div>
			<div class="formBox" v-if="formDatas">
				<el-form 
					:model="formDatas"					
					ref="formDatas"
					label-position="top"
					class="MT10">
					<el-form-item prop="status">
						<span slot="label">候补开关: </span>
						<el-radio-group v-model="formDatas.status"> <!--   :disabled="formDatas.status == 1 ? true : false"  -->
							<el-radio :label="1">开启<span class="mark">（开票后无剩余可购库存时，将会自动开启 ）</span></el-radio><br><br>
							<el-radio :label="0">关闭</el-radio>
						</el-radio-group>
						<div class="color-danger MT20 redText">
							注意：
							<p>1、候补自动关闭时间，livehouse在演出开始前24小时，其他活动类型演出在演出开始前48小时</p>
							<p>2、候补关闭后，未候补成功的用户将自动候补失败（退款自动原路返回）</p>
						</div>
					</el-form-item>
					<el-form-item prop="isStockToAlternate">
						<p>增加库存或退票，优先满足候补中的用户，如有富裕，则：</p>
						<el-radio-group v-model="formDatas.isStockToAlternate">
							<el-radio :label="0">自动回到普通库存，进行正常售卖</el-radio><br><br><br>
							<el-radio :label="1">保留在候补库存，即不进行正常售卖，仅留给后续参与候补的用户</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item prop="alternateCloseTime" :rules="[{ required: true, message: '请填写自动关闭候补的时间' }]" v-if="formDatas.status == 1">
					    <span slot="label">自动关闭候补时间: </span>
					    <el-date-picker
						  size="small"
						  v-model="formDatas.alternateCloseTime"
						  type="datetime"
						  value-format="yyyy-MM-dd HH:mm:ss"
						  format="yyyy-MM-dd HH:mm:ss"
						  placeholder="自动关闭候补的时间">
					    </el-date-picker>
					</el-form-item>
					<el-form-item prop="alternateMaxNum">
						<span slot="label">候补队列长度:</span>
						<el-input-number style="width:100%" v-model="formDatas.alternateMaxNum" :precision="0" controls-position="right" :min="0" :max="300000" size="medium"  placeholder="请输入候补队列长度"></el-input-number>
						<div style="margin-top: -10px;">
							<span class="mark">最大允许通过同时等待候补的票数，建议参考票品库存情况进行合理设置</span>
							<div class="houbulink" v-if="itemData && itemData.amidCount > 0">当前候补中：<span >{{itemData.amidCount}}</span> <el-link class="link color-blue" target="_blank" :href="`/activityManage/order/list?searchType=13&searchValue=${itemData.id}&isAlternateOrder=1`" >查看候补订单</el-link></div>
						</div>
					</el-form-item>
					<el-form-item prop="alternatePay">
						<span slot="label">支付模式:</span>
						<el-radio-group v-model="formDatas.alternatePay">
							<!-- <el-radio :label="0">正常支付</el-radio><br><br><br> -->
							<el-radio :label="1">支付宝预授权+其他方式正常支付</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item style="line-height: 24px;">
						<span slot="label">乐迷服务费:</span>
						<el-input-number style="width:90%" v-model="formDatas.alternateServiceFee" :precision="1" controls-position="right" :min="0.0" :max="100" size="medium"  placeholder="请输入候补队列长度"></el-input-number> %
						<div class="mark">该费用面向乐迷收取（需要乐迷支付更多），比例以设置为准，<span class="color-danger">最低5元<br>注意：乐迷服务费不结算给主办</span></div>
					</el-form-item>
				</el-form>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确 认</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    status:'',
    ticketId:'',
	alternateMaxNum:'',
	alternateCloseTime:'',
	isStockToAlternate:'',
	alternatePay:0,
	alternateServiceFee:5.5
}
export default {
    props:{
        activityId:{
            type:[Number,String],
            default:''
        },
		
    },
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            formDatas:{
                ...defaultFormData
            },            
            itemData: null,
			itemTime:''
        }
    },
    methods:{
        close(){
            this.$refs.formDatas.resetFields();
            this.drawerShow = false;
            this.formDatas = {
                ...defaultFormData
            }
        },
        show(itemData,time){
            this.itemData = itemData;			
			this.itemTime = time;
            this.formDatas.ticketId = itemData.id; 
			this.formDatas.status = itemData.isOpenAlternate;
			this.formDatas.alternateMaxNum = itemData.alternateMaxNum ? itemData.alternateMaxNum : '';
			this.formDatas.alternateCloseTime = itemData.alternateCloseTime
			this.formDatas.isStockToAlternate = itemData.isStockToAlternate
			this.formDatas.alternatePay = itemData.alternatePay
			this.formDatas.alternateServiceFee = itemData.alternateServiceFee ? itemData.alternateServiceFee : 5.5
			// var alternateCloseTime2= new Date(time.substr(0, 19)).getTime()-1800000;			
			// this.formDatas.alternateCloseTime = itemData.alternateCloseTime ? itemData.alternateCloseTime : this.$utils.formatDate(alternateCloseTime2, 'yyyy-MM-dd HH:mm:ss' )
			// console.log( this.formDatas.alternateCloseTime )
			this.drawerShow = true;
			
			
			//this.formDatas.alternateCloseTime = this.$utils.formatDate(alternateCloseTime2, 'yyyy-MM-dd HH:mm:ss' )
        },
        //表单提交
        submitForm() {
			
			if( this.formDatas.status == 1 && (this.formDatas.alternateMaxNum == 0 || !this.formDatas.alternateMaxNum ) ){
				this.$message.error("请填写合理的候补队列长度!");
				return
			}
			var _msg =''; var _timeMsg = '';
			if( this.formDatas.status  == 1 && this.formDatas.alternateCloseTime > this.itemData.endTime  ){
				
				_timeMsg = "当前时间晚于票品销售截止时间，继续修改将同步修改销售截止时间!"
			}
			
			// if( this.formDatas.status  == 1 && this.itemTime ){
			// 	var alternateCloseTimeCut =  new Date(this.itemTime.substr(0, 19)).getTime();
				
			// 	var alternateCloseTimeCut2 = new Date(this.formDatas.alternateCloseTime).getTime();
			// 	var differ = (alternateCloseTimeCut - alternateCloseTimeCut2)/60000;				
				
			// 	if( differ < 30 ){
			// 		this.$message.error("自动关闭候补时间不能晚于开演前30分钟!");
			// 		return
			// 	}
			// 	if(  differ < 360 ){
			// 		_msg = `<div class="color-danger">用户出行存在时间成本，自动关闭候补时间不建议晚于开演时间前360分钟，是否继续？</div>`;
			// 	}
				
			// }
			if( this.formDatas.status  == 1 ){
				_msg = `<div>将会开启候补。<br>请先仔细阅读候补开关注意事项，再确认开启。<br>` + `<p class="color-danger">` + _timeMsg + `</p></div>`;				
			}
			
			// if( this.formDatas.status  == 0 && this.itemData.isOpenConsign  == 1 ){
			//     _msg = `<div class="color-danger"><p>当前存在待托售的订单</p>关闭候补后，会同时让托售订单失效，是否关闭候补？</div>`;
			// }
			if( this.formDatas.status  == 1 ){
				this.$confirm(_msg, '提示', {
					// type: 'success',
					//center: true,
					confirmButtonText:'确认提交',
					cancelButtonText:'取消',
					dangerouslyUseHTMLString: true,
					closeOnClickModal: false
				}).then(() => {
					this.$refs["formDatas"].validate((valid) => {
						if (valid) {
							this.submitFun()
						} else {
							return false;
						}
					});
				}).catch(() => {
					
				})
			}else{
				this.submitFun()
			}
        },
		submitFun(){
			
			this.btnLoading = true;
			this.$request({
				url: '/activity/openAlternate',
				data: {
					...this.formDatas,
					activityId: this.activityId,
					alternateCloseTime:this.formDatas.status == 1 ? this.formDatas.alternateCloseTime : ''
				},
				method: "post",
			})
				.then((res) => {
					const { state, msg } = res.data;
					if (state == 1) {
						this.$emit("onUpdate");
						//window.location.reload()
						this.close();
						
					} else {
						this.$message.error(msg || "操作失败,请重试");
					}
				})
				.catch(() => {
					self.$message.error("操作失败,请重试");
				})
				.finally(() => {
					this.btnLoading = false;
				});   
		}
    }
}
</script>
<style lang="scss" scoped>
.houbulink{
	line-height: 24px;
	height: 24px;
}
.el-link.el-link--default{
	color:#409EFF;
	margin: -6px 0 0 10px;
}
.formBox{
	margin-top: 20px;
	
}
.redText{
	font-size: 12px;
	line-height: 24px;
}
.card1{
	font-size: 14px;
}
.item{
    margin-bottom: 20px;
}
.mark{
	font-size: 12px;
	line-height: 24px;
}
</style>